// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 1237 ? "BaseComponent" : chunkId) + "." + {"97":"bd85c5c2","829":"e9b61a61","1237":"80a42531","2918":"b747255e","7358":"972158b5","9867":"996dd19e"}[chunkId] + ".css";
};